

<!-- Header Section -->
<div class="page-header col-md-12 p-3">
    <div class="row">
      <div class="col-md-4">
        <h3 class="page-title" translate>Search User's Appointment</h3>
        <ol class="breadcrumb bg-white p-0">
          <li class="breadcrumb-item active" aria-current="page">Appointment</li>
        </ol>
      </div>
      <div class="col-md-8 d-none d-md-flex justify-content-md-end align-items-center">

        <button class="btn mx-1 border border-white rounded"  (click)='backClicked()' translate ><i class="fa fa-times"></i> BACK</button>
        <button class="btn mx-1 border border-white rounded" (click)='editClient(clientDetails[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate ><i class="fa fa-times"></i> EDIT</button>
        <button class="btn mx-1 border border-white rounded" (click)='deleteClient(clientDetails[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate ><i class="fa fa-times"></i> DELETE</button>
      </div>
  
      <!-- Mobile Dropdown -->
      <div class="col-12 d-flex d-md-none justify-content-end">
        <div ngbDropdown class="d-flex d-md-none justify-content-end mt-2">
          <button class="btn btn-light border no-arrow" ngbDropdownToggle>
            <i class="fa fa-ellipsis-h"></i>
          </button>
          <div ngbDropdownMenu class="dropdown-menu-right">
            <a class="dropdown-item border-bottom p-2"  (click)='backClicked()' translate ><i class="fa fa-times mr-1"></i> BACK </a>
        
            <a class="dropdown-item border-bottom p-2" href="#" (click)='editClient(clientDetails[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate ><i class="fa fa-times mr-1"></i> EDIT</a>
            <a class="dropdown-item border-bottom p-2" href="#"  (click)='deleteClient(clientDetails[0])' *ngIf="isSystemAdmin() || isAdmin() || isReceptionist()" translate ><i class="fa fa-times mr-1"></i> DELETE</a>
  
  </div>
  </div>
  </div>
  </div>
  </div>
	

        



<div class="col-md-12 mt-2 bg-white  border-black">
    <ul class="nav nav-tabs   border-0 text-center mx-1 pt-2 d-flex justify-content-start">
    
        <li class="nav-item flex-wrap mx-1  " >
          <a class="nav-link active p-3  "  style="font-size: smaller; border:2px solid #132a42; border-radius: 15px 15px 5px 5px; cursor: pointer;" id="salesrepappointmentview"  translate>Sales Rep Appointment</a>
      
          <li class="nav-item flex-wrap mx-1  " >
            <a class="nav-link active p-3 "  style="font-size: smaller; border:2px solid #132a42; border-radius: 15px 15px 5px 5px; cursor: pointer;" id="clientsview" translate >Clients</a>
          </li>
    
        
      
            </ul>
      
        </div>

  







        <div class=" col-md-12 bg-white  pb-5 rounded" id="salesrepappointment">

    
            <!--*********************************************************************************************************************************************************************************************************************************-->
<div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="todayTableview" >
    <div class=" d-flex justify-content-between row w-85 pt-2 mx-1">
    
  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
        <div id="notificationSlide" class="carousel slide " data-ride="carousel">
            <div class="col-md-5 form-group py-2" *ngIf='branchselected'>
                <form >
                <label class="text-left font-weight-bold p-2 rounded w-100" style="font-size: small; font-family:'DINPro'" translate>Sales Representative</label>
                <select class=" p-2 select2tag select2-hidden-accessible"
                     id="salesRep" name="salesRep"
                    style="width: 100%;font-size: smaller;" tabindex="-1" aria-hidden="true"
                    (change)="getSalesRepAppointment($event.target.value)"
                   >
                    <!--<option value='0'>SELECT</option>-->
                    <option   value="">SELECT
                    <option  *ngFor='let rep of salesRep'  value={{rep.userID}}>{{rep.fullName}}
              
                </select>
            </form>
            </div> 
  
            <!-- Indicators -->
            <ul class="carousel-indicators">
                <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                <li data-target="#assetSlide" data-slide-to="1"></li>
                <li data-target="#assetSlide" data-slide-to="2"></li>
            </ul>
  
            <!-- The slideshow -->
            <div class="carousel-inner">
                <div class="carousel-item active">
  
                  
                    <div class=" border p-3 m-1 rounded   " >
                        <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: #132a42;" > <div class="p-1 mr-3">
                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                   aria-label="Search" >
                 </div></h6>
                        
                <div  style="overflow:auto;" *ngIf="mytableappointment!=['no appointment'] else no_appointment_content" >
                    <table class="table table-striped w-100  text-center"  style="font-size: 12px;">
                                
                     <thead>  
                        <th class=" p-2" translate>Full Name</th>
                        <th class="text-center p-2" translate>Request Type</th>
                        <th class="text-center p-2" translate>Sales Rep</th>
                        <th class="text-center p-2" translate>Phone</th>
                        <th class="text-center p-2" translate>Time In</th>
                        <th class="text-center p-2" translate>Time Out</th>
                        <th class="text-center p-2" translate>Tag</th>
                        <th class="text-center p-2" translate>Status</th>
                        <th class="text-center p-2" translate *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">Action</th>
                        <th *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() "></th>
                    </thead>
                    <tbody>
                        <ng-container *ngFor='let list of mytableappointment | filter:searchText '>
                          <tr style="color: purple;" *ngIf='checkbarScan(list.barScan) && list.requestType!="Browsing" else other_content'  [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                              <td class="" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                              <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                              <td class="text-center " (click)=openAppointment(list) [style.border-bottom]="'5px solid ' + list.salesRepColor" style="cursor: pointer;"  >{{list.salesRep}}</td>
                             <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                             <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center " (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                             
                            
                            
                            
                             <td  *ngIf="list.status==''" class="text-white bg-warning text-center  " ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Pending'" class="text-white bg-warning text-center "  ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='No Show'" class="text-white bg-danger text-center " ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='In Progress'" class="text-white bg-primary text-center " ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Completed'" class="text-white bg-success text-center  "><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Cancelled'" class="text-white bg-danger text-center "><strong>{{list.status}}</strong></td>
    
                              <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                  <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                  <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                  <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                  <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                  <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                  <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                 
                              </td>
                             
                                         <td> <i class="fa fa-toggle-on text-info p-2"  *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() "style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                          </tr>
    
    
    
                         
    
                          <ng-template #other_content>
    
    
    
    
                              <tr class="text-success " *ngIf='list.requestType=="Browsing" else else_content'  [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                                  <td class="" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                                  <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                                  <td class="text-center " (click)=openAppointment(list) [style.border-bottom]="'5px solid ' + list.salesRepColor" style="cursor: pointer;"  >{{list.salesRep}}</td>
                                 <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                                 <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                                 <td class="text-center " (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                                 
                                
                                
                                
                                 <td  *ngIf="list.status==''" class="text-white bg-warning text-center  " ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Pending'" class="text-white bg-warning text-center  " ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='No Show'" class="text-white bg-danger text-center  " ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='In Progress'" class="text-white bg-primary text-center " ><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Completed'" class="text-white bg-success text-center  "><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status=='Cancelled'" class="text-white bg-danger text-center  "><strong>{{list.status}}</strong></td>
                                  <td  *ngIf="list.status==''" class="text-center  p-3"><strong>{{list.status}}</strong></td>
    
      
                                  <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                      <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                  <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                  <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                  <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                  <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                  <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                     
                                  </td>
                                 
                                             <td> <i class="fa fa-toggle-on text-info p-2"  *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() " style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                              </tr>
    
                        
    
    
  
    <ng-template #else_content>
    
    
                          <tr  [ngClass]="{'completedstatus':list.status=='Completed','pendingstatus':list.status=='Pending','progressstatus':list.status=='In Progress','cancelledstatus':list.status=='Cancelled','noshowstatus':list.status=='No Show'}">
                              <td class="" (click)=openAppointment(list) style="cursor: pointer;" >{{list.fullName}}</td>                           
                              <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;"  >{{list.requestType}}</td>
                              <td class="text-center " (click)=openAppointment(list) [style.border-bottom]="'5px solid ' + list.salesRepColor" style="cursor: pointer;"  >{{list.salesRep}}</td>
                             <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.phoneNumber}}</td>
                             <td class="text-center" (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center " (click)=openAppointment(list) style="cursor: pointer;" >{{list.timeOut  | date:'yyyy-M-d h:mm a'}}</td>
                             <td class="text-center " (click)=openTagModal(tagModal,list) style="cursor: pointer;" >{{list.tag}}</td>
                            
                            
                            
                             <td  *ngIf="list.status==''" class="text-white bg-warning text-center  p-3" ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Pending'" class="text-white bg-warning text-center " ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='No Show'" class="text-white bg-danger text-center  " ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='In Progress'" class="text-white bg-primary text-center  " ><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Completed'" class="text-white bg-success text-center  "><strong>{{list.status}}</strong></td>
                              <td  *ngIf="list.status=='Cancelled'" class="text-white bg-danger text-center  "><strong>{{list.status}}</strong></td>
    
                              <td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                 
                               <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                  <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                  <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                  <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                  <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                  <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                              
                              </td>
                             
                                         <td></td>
                          </tr>
                          </ng-template><!--End of Else Content-->
                     
                          </ng-template><!--End of Other Content-->

                 
                  
                      </ng-container>
                    </tbody>
                    </table>
                  
               </div>
               <ng-template #no_appointment_content>
                <table class="table w-100  text-center"  style="font-size: 12px;">
                    
           
                    <th class=" p-2" translate>Full Name</th>
                    <th class="text-center p-2" translate>Request Type</th>
                    <th class="text-center p-2" translate>Sales Rep</th>
                    <th class="text-center p-2" translate>Phone</th>
                    <th class="text-center p-2" translate>Time In</th>
                    <th class="text-center p-2" translate>Time Out</th>
                    <th class="text-center p-2" translate>Tag</th>
                    <th class="text-center p-2" translate>Status</th>
         <tr>
                  <td colspan="8" class="col-span-8 text-center">no appointment
                </td>
            </tr>
                </table>
              </ng-template>
                    </div>
                </div>
                   
            </div>
  
   
        </div>
      
  </div>
  
  
  
        </div>
  
        </div>
  
  
  
            </div>

<!------------------------------------------------------------------------------------------------------------->
            <div class=" col-md-12 bg-white mt-1 pb-5 rounded" id="clients">
                <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; background: white;" id="todayTableview" >
                    <div class=" d-flex justify-content-between row w-85 mt-2 mx-1">
                    
                  <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 " style="min-width: 48%;"  >
                        <div id="notificationSlide" class="carousel slide " data-ride="carousel">
                           
                  
                            <!-- Indicators -->
                            <ul class="carousel-indicators">
                                <li data-target="#assetSlide" data-slide-to="0" class="active"></li>
                                <li data-target="#assetSlide" data-slide-to="1"></li>
                                <li data-target="#assetSlide" data-slide-to="2"></li>
                            </ul>
                  
                            <!-- The slideshow -->
                            <div class="carousel-inner">
                                <div class="carousel-item active">
                  
                                  
                                    <div class=" border p-3 m-1 rounded   " >
                                        <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: rgb(17, 47, 77);"  > <div class="p-1 mr-3">
                                            <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search"  [(ngModel)]="searchText"
                                   aria-label="Search" >
                                 </div></h6>
                                        
                                <div  style="overflow:auto;"  >
                                  
                                                
                                    <ng-container *ngIf="clientSearchList!='no clients found' else no_appointment_content">
                                            <table class="  table table-striped" >
                                                <thead style="font-size: 12px;">
                                                <th class="text-center p-2 " translate>Full Name</th>
                                                <th class="text-center p-2 " translate>Phone Number</th>
                                                <th class="text-center p-2 " translate>Email</th>
                                                <th class="text-center p-2 " translate>Type</th>
                                                <th class="text-center p-2 " translate>Company Name</th>
                                                </thead>
                                                <tbody>
                                                <tr  *ngFor='let list of clientSearchList | filter:searchText' style="font-size: small;">
                                                    
                                                    <td  class="p-2 text-center" style="cursor: pointer;" (click)="openClientDetails(list)" data-dismiss="modal">{{list.fullName}}</td>     
                                                    <td  class="p-2 text-center" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.phoneNumber | phone}}</td>   
                                                    <td  class="p-2 text-center" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.email}}</td>   
                                                    <td  class="p-2 text-center" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.describesYou}}</td>   
                                                    <td  class="p-2 text-center" style="cursor: pointer;" (click)="openClientDetails(list)"  data-dismiss="modal">{{list.companyName}}</td>   
                                                    
                                                   
                                               
                                                </tr>
                                                </tbody>
                                </table>
                            </ng-container>
                                <ng-template #no_appointment_content>
                                    <table class="table w-100  text-center"  style="font-size: 12px;">
                                        
                               
                                        <thead >
                                            <th class="text-center p-2 " translate>Full Name</th>
                                            <th class="text-center p-2 " translate>Phone Number</th>
                                            <th class="text-center p-2 " translate>Email</th>
                                            <th class="text-center p-2 " translate>Type</th>
                                                <th class="text-center p-2 " translate>Company Name</th>
                                            </thead>
                             <tr>
                                      <td colspan="8" class="col-span-8 text-center">no appointment
                                    </td>
                                </tr>
                                    </table>
                                  </ng-template>
                                    </div>
                                </div>
                                   
                            </div>
                  
                   
                        </div>
                      
                  </div>
                  
                  
                  
                        </div>
                  
                        </div>
                  
                  

                </div>
